// Forms
Vue.component('address-line', require('./VueComponents/Helpers/AddressLine').default);
Vue.component('password-field', require('./VueComponents/Helpers/PasswordField').default);
Vue.component('datepicker', require('./VueComponents/Helpers/Flatpickr').default);
Vue.component('csrf-field', require('./VueComponents/Helpers/CsrfField').default);
Vue.component('image-uploader', require('./VueComponents/DropzoneImageUploader').default);
Vue.component('newsletter-box', require('./VueComponents/Forms/NewsletterBox').default);
Vue.component('stripe-identity-modal', require('./VueComponents/Checkout/StripeIdentityModal').default)

// Anderes
//Vue.component('cta-bar', require('./VueComponents/Helpers/CTABar'));
Vue.component('loader', require('./VueComponents/Helpers/Loader').default);

// GoogleMaps
Vue.component('map-navigation', require('./VueComponents/Helpers/MapNavigation').default);

// Alerts and notifications
Vue.component('alert', require('./VueComponents/Helpers/Alert').default);
Vue.component('Success', require('./VueComponents/Helpers/Success').default)
